import { ReactNode } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { SPACINGS } from 'shared/styles/variables';
import { createGlobalStyle } from 'styled-components';

import { INQUIRY_RTL_LANGUAGES, InquiryLanguage } from 'lib/constants/locales';

interface LocalizedDirectionProps extends WithTranslation {
  children: ReactNode;
}

// TODO Make elements handle their own localization styles
const RTLDirectionStyles = createGlobalStyle`
  select {
    padding-right: ${SPACINGS.base * 3}px !important;
  }

  h4 {
    padding-left: 0px !important;
    padding-right: ${SPACINGS.base * 3}px !important;
  }
`;

export const LocalizedDirection = ({ children, i18n }: LocalizedDirectionProps) => {
  const direction =
    INQUIRY_RTL_LANGUAGES.indexOf(i18n.language as InquiryLanguage) >= 0 ? 'rtl' : 'ltr';

  return (
    <div dir={direction} data-test='localized-direction'>
      {direction === 'rtl' && <RTLDirectionStyles />}

      {children}
    </div>
  );
};

export default withTranslation()(LocalizedDirection);
